var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppModal", {
    attrs: { persistent: "", "max-width": "750px" },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "app-modal-title",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "app-modal-alert",
        fn: function () {
          return [
            !_vm.implemented
              ? _c("ColumnNotImplementedMessage", {
                  attrs: { value: !_vm.implemented },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasValidateAllValues && _vm.implemented
              ? _c("MandatoryColumnMessage", {
                  attrs: { value: _vm.hasValidateAllValues && _vm.implemented },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "app-modal-text",
        fn: function () {
          return [
            _vm.configuration == null
              ? [
                  _vm._v(
                    "\n      Unknown column " + _vm._s(_vm.columnId) + "\n    "
                  ),
                ]
              : _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _vm.hasDescription
                      ? _c(
                          "v-flex",
                          {
                            attrs: {
                              xs12: "",
                              "pb-2": "",
                              "data-ui-component": "column-description",
                            },
                          },
                          [
                            _c(
                              "v-card-title",
                              { staticClass: "title px-0 pb-2" },
                              [_vm._v("Description")]
                            ),
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.configuration.Description) +
                                "\n      "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _vm._t("edit-modal-additions", null, {
                          configName: _vm.configName,
                          columnConfiguration: _vm.configuration,
                          editMode: _vm.editMode,
                          implemented: _vm.implemented,
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    !_vm.hasValidateAllValues && _vm.implemented
                      ? _c(
                          "v-flex",
                          {
                            attrs: {
                              xs12: "",
                              "data-ui-component": "skip-value-table",
                            },
                          },
                          [
                            _c(
                              "v-card-title",
                              { staticClass: "title px-0 pb-2" },
                              [
                                _vm._v("\n          Skip Values\n          "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "success",
                                      disabled:
                                        !_vm.editMode || !_vm.implemented,
                                    },
                                    on: { click: _vm.handleAddSkipValue },
                                  },
                                  [_vm._v("Add Skip Value")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-card-text", { staticClass: "pt-0" }, [
                              _vm._v(
                                "\n          If a skip value is encountered in any cell within this column, the cell will be treated as an empty cell.\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("SkipValueTable", {
                              ref: "skipValueTable",
                              attrs: {
                                columnConfiguration: _vm.configuration,
                                configName: _vm.configName,
                                editMode: _vm.editMode,
                                implemented: _vm.implemented,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        attrs: { xs12: "", "data-ui-component": "alias-table" },
                      },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "title px-0 pb-2" },
                          [
                            _vm._v(
                              "\n          Column Name Aliases\n          "
                            ),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "success",
                                  disabled: !_vm.editMode || !_vm.implemented,
                                },
                                on: { click: _vm.handleAddAlias },
                              },
                              [_vm._v("Add Alias")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-card-text", { staticClass: "pt-0" }, [
                          _vm._v(
                            "\n          Any alias in the table will be treated as match to the column.\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ColumnNameAliasTable", {
                          ref: "nameAliasTable",
                          attrs: {
                            columnConfiguration: _vm.configuration,
                            configName: _vm.configName,
                            editMode: _vm.editMode,
                            implemented: _vm.implemented,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "app-modal-actions",
        fn: function () {
          return [
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              { attrs: { color: "primary" }, on: { click: _vm.close } },
              [_vm._v("Done")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.modalValue,
      callback: function ($$v) {
        _vm.modalValue = $$v
      },
      expression: "modalValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }